import { Component, Inject, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "unit-details-dialog",
  templateUrl: "unit-details-dialog.html",
})
export class UnitDetailsDialog implements AfterViewInit {
  params: any;
  unit: any;
  status: any;

  constructor(
    public dialogRef: MatDialogRef<UnitDetailsDialog>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  ngAfterViewInit() { }

}
